<template>
  <div class="form-group">
    <label v-if="label" :for="`${type}-${_uid}`">{{ label }}</label>

    <select-dropdown
      v-model="optionSelected"
      :class-select="customClass"
      :state="state === false ? 'is-invalid' : ''"
      :placeholder="placeholder"
      :options="options"
      :disabled="disabled" @input="onSelectOption"/>

    <!-- This will only be shown if the preceding input has an invalid state -->
    <b-form-invalid-feedback :id="`input-live-feedback-${_uid}`" v-if="showErrors">
      <ul class="error-content">
        <li class="error-text" v-for="(error, index) in errors" :key="`select-error-${_uid}-${index}`">
          {{ error }}
        </li>
      </ul>
    </b-form-invalid-feedback>
  </div>
</template>

<script>
import {SelectDropdown} from "@/core/components/SelectDropdown";

export default {
  name: "Select",
  components: {
    'select-dropdown': SelectDropdown,
  },
  data: function () {
    return {}
  },
  props: {
    value: {
      type: [Number, String],
    },
    showErrors: {
      type: Boolean,
      default: true
    },
    errors: {
      type: Array,
      default: function () {
        return []
      }
    },
    options: {
      type: Array,
      default: function () {
        return []
      }
    },
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    customClass: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    onSelectOption(value) {
      this.$emit('input', value)
    },
  },
  computed: {
    /**
     * false (denotes invalid state) is great for when there's a blocking or required field. A user must fill in this field properly to submit the form.
     * true (denotes valid state) is ideal for situations when you have per-field validation throughout a form and want to encourage a user through the rest of the fields.
     * null Displays no validation state (neither valid nor invalid)
     * @returns {boolean}
     */
    state() {
      return !this.errors.length ? null : false
    },
    optionSelected: {
      get: function () {
        return this.value ?? ''
      },
      set: function () {
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
::v-deep
  .custom-dropdown
    ::v-deep
      .dropdown-toggle
        span
         color color-7
</style>
